import { UNPROCESSABLE_ENTITY } from '@mm/constants/status-codes';
import { getErrorJson } from '@mm/utils';
import { isString } from 'lodash';
import { Dispatch } from 'redux';
import { unbusyAll } from '../actions/commonActions';
import modalActions from '../modules/modalsState/actions';
import { StoreState } from '../store-interfaces';
import commonHandler, { ResponseOrError } from './common-handler';

const PAYMENT_ERROR_MESSAGE = `
  Uh-oh. We were unable to process your payment. Please double check that your payment information is correct.
  If this problem persists, please contact us at billing@customers.ai.`;

const prepareMessages = async (error: Response) => {
  const json = await getErrorJson(error);

  if (json && Array.isArray(json.errors)) {
    return json.errors.reduce((errorMessages, error) => {
      return error && isString(error)
        ? `${errorMessages} \n ${error}`
        : errorMessages;
    }, '');
  }
};

export class CheckoutError extends Error {
  constructor(message) {
    super(message);
    this.name = 'CheckoutError';
  }
}

export const subscriptionErrorHandler =
  (dispatch: Dispatch<StoreState>) => async (error: ResponseOrError) => {
    if (error instanceof Response && error.status === UNPROCESSABLE_ENTITY) {
      const messages = await prepareMessages(error);

      const errorMessage = messages || PAYMENT_ERROR_MESSAGE;

      if (window.MMApp?.throwErrors) {
        throw new CheckoutError(errorMessage);
      }

      dispatch(
        modalActions.openPrettyErrorModal({
          title: 'Checkout Error',
          errorMessage,
        }),
      );

      dispatch(unbusyAll());
    } else {
      commonHandler(dispatch)(error);
    }
  };
